<template>
    <div style="display: flex; align-items: center;">
        <div style="margin-right: 8px;" @click="showProfile">
            <ProfileImage style="width: 40px;" :image-path="memberInfo.image_path"></ProfileImage>
        </div>
        <div style="flex: 1; display: flex; align-items: center; gap: 3px;">
            <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ memberInfo.nic_name }}</div>
            <div v-if="memberInfo.is_coach == 0" style="font-weight: 700; font-size: 14px; color: var(--color-main);">{{ memberInfo.position }}</div>
            <div style="margin-left: 4px;" v-else>
                <img v-if="memberInfo.team_type === TEAM_TYPE.CLASS_1_PRO_TEAM" style="width: 13px;" :src="require('@/assets/img/blue_star.png')" alt="">
                <img v-else style="width: 13px;" :src="require('@/assets/img/yellow_star.png')" alt="">
            </div>
        </div>
        <!-- <div v-if="curLikeYn !== IS_LIKE.LIKE" @touchstart="touchStart" @touchend="touchEnd" style="border: 1px solid #bbbbbb; border-radius: 8px; width: 67px; height: 32px; text-align: center; display: flex; justify-content: center; align-items: center;">
            <div @touchstart.stop="touchStart" @touchend.stop="touchEnd" v-if="!isShowBallImage && curLikeYn === IS_LIKE.UNLIKE" style="font-weight: 700; font-size: 12px; line-height: 32px; ">슈팅</div>
            <div @touchstart.stop="touchStart" @touchend.stop="touchEnd" v-else-if="!isShowBallImage && curLikeYn === IS_LIKE.LIKE" style="font-weight: 700; font-size: 12px; line-height: 32px; ">슈팅됨</div>
            <div style="position: relative;" @touchstart.stop="touchStart" @touchend.stop="touchEnd" v-else>
                <img :style="{ opacity: curLikeYn === IS_LIKE.LIKE ? '1' : '0' }" ref="shoot" style="width: 40px; z-index: 1; opacity: 0; left: -15px; position: absolute; top: -1px;" :src="require('@/assets/img/shoot_orange.png')" alt="">
                <img style="width: 16px; position: relative; z-index: 2; left: 0;" ref="soccerBall" :src="require('@/assets/img/soccer_ball_reply_active.png')" alt="">
            </div>
        </div> -->
    </div>
</template>

<script>
import ProfileImage from '@/components/common/ProfileImage'
import { MEMBER_TYPE, TEAM_TYPE } from "../../Constants";

const IS_LIKE = {
    LIKE: 1,
    UNLIKE: 0
}

export default {
    name: 'CommonProfile',
    components: { ProfileImage },
    props: {
        memberInfo: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            IS_LIKE: IS_LIKE,
            test: 0,
            isShowBallImage: false,
            TEAM_TYPE: TEAM_TYPE
        }
    },
    computed: {
        curLikeYn() {
            return parseInt(this.test)
        },
    },
    methods: {
        showProfile() {
            this.$Util.showProfile(this.memberInfo.idx, MEMBER_TYPE.USER, this.memberInfo.is_temp_coach);
        },
        touchStart() {
            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.isShowBallImage = true
            }
        },
        touchEnd() {
            if (this.curLikeYn === IS_LIKE.UNLIKE) {
                this.$refs.soccerBall.style.transition = 'all 0.3s'
                this.$refs.soccerBall.style.transform = 'rotate(60deg)'
                this.$refs.soccerBall.style.left = '8px'
                this.$refs.shoot.style.opacity = '1'
                this.$refs.shoot.style.transition = 'all 0.3s'
                setTimeout(() => {
                    this.isShowBallImage = false
                    this.test = 1
                }, 1000)
            } else {
                this.test = 0
                this.isShowBallImage = false
            }

            // let likeTemp = this.curLikeYn === IS_LIKE.UNLIKE ? '1' : '0'
            // let likeNumber = this.curLikeYn === IS_LIKE.UNLIKE ? this.curLikeNumber + 1 : this.curLikeNumber - 1
            // this.$set(this.copySoccerHows, 'like_yn', likeTemp);
            // this.$set(this.copySoccerHows, 'like_number', likeNumber);
            // this.toggleLike()
        },
    }
}
</script>

<style scoped></style>